// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"b433edc5","367":"b31c6574","640":"7946f438","759":"a778d1d1","946":"d9371761"}[chunkId] + ".chunk.js";
};